/**
 * 充值记录
 * Create by liaokai on 2020-04-15 18:15:45
 */
import * as React from 'react';
import {Component} from "react";
import {RouteComponentProps} from "react-router";
import {SurfaceRouter, tSurfaceRouteItem} from "../../../../components/surface-router/surface-router";
import {PrepaidRecord} from "./index/prepaid-record";

interface IProps extends RouteComponentProps{

}

interface IState{

}

const routerData : tSurfaceRouteItem = {
    breadTitle : "收支记录",
    routeName : "",
    component : PrepaidRecord,
    children : []
};

export class PrepaidRecordRouter extends Component<IProps,IState>{
    readonly state : IState = {

    };
    render() {
        let {} = this.props;
        let {} = this.state;
        return (
            <SurfaceRouter {...this.props} entryRoute={routerData}/>
        );
    }
}
